"use client";

import { navCta, navLinks } from "@/config/navigation";
import { useScrollState } from "@/lib/hooks/useScrollState";

export function Nav() {
  const { scrolled, pastHero, progress } = useScrollState();

  const linkColor = scrolled ? "text-slate-text" : "text-white";

  return (
    <>
      <a
        href="#obsah"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-surface focus:px-4 focus:py-3 focus:text-sm focus:font-medium focus:text-ink-text"
      >
        Přeskočit na obsah
      </a>

      <header
        className={[
          "fixed inset-x-0 top-0 z-50 h-[72px] border-b transition-colors duration-200",
          scrolled
            ? "border-hairline bg-surface"
            : "border-transparent bg-transparent",
        ].join(" ")}
      >
        <div className="container-site flex h-full items-center justify-between gap-4">
          <a
            href="#hero"
            aria-label="aComputer — na začátek stránky"
            className="text-lg leading-none text-blue"
          >
            <span className="font-bold">a</span>
            <span className="font-normal">Computer</span>
          </a>

          <nav aria-label="Hlavní navigace" className="flex items-center gap-4 md:gap-6">
            <ul className="hidden items-center gap-5 sm:flex lg:gap-8">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className={[
                      "inline-flex min-h-[44px] items-center transition-colors duration-200",
                      linkColor,
                    ].join(" ")}
                  >
                    <span className="link-draw overline">{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>

            <a
              href={navCta.href}
              className={[
                "inline-flex min-h-[44px] items-center px-5 text-[11px] font-bold uppercase tracking-[0.18em] transition-colors duration-200",
                pastHero
                  ? "bg-red text-white hover:bg-red-dark"
                  : "border border-white text-white hover:bg-white hover:text-ink-900",
              ].join(" ")}
            >
              {navCta.label}
            </a>
          </nav>
        </div>

        <div
          aria-hidden="true"
          className="absolute bottom-0 left-0 h-px w-full origin-left bg-blue"
          style={{ transform: `scaleX(${progress})` }}
        />
      </header>
    </>
  );
}
